class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeyDown);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    this.#handleSwatchSelection(e, swatch);
  };

  #onKeyDown = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    this.#handleSwatchSelection(e, swatch);
  };

  #handleSwatchSelection(event, swatch) {
    event.preventDefault();
    event.stopPropagation();

    if (swatch.dataset.updateProductCardMedia === 'true') {
      this.#updateProductCardMedia(swatch);
      this.#updateSelectedSwatch(swatch);
      this.#updateQuickAdd(swatch);
      return;
    }

    window.location.href = swatch.dataset.href;
  }

  #updateProductCardMedia(swatch) {
    const productCard = this.closest('product-card');
    if (!productCard) return;

    productCard.dataset.productUrl = swatch.dataset.href;

    const mediaGallery = productCard.querySelector('product-card-media-gallery');
    if (!mediaGallery) return;

    const image =
      mediaGallery.querySelector('.product-card-media-gallery__media > .product-media img') ||
      mediaGallery.querySelector('.splide__slide.product-card-media-gallery__media .product-media img');
    if (!image) return;

    const imageSrc = swatch.dataset.variantImageSrc;
    if (!imageSrc) return;

    image.src = imageSrc;

    if (swatch.dataset.variantImageSrcset) {
      image.srcset = swatch.dataset.variantImageSrcset;
    } else {
      image.removeAttribute('srcset');
    }

    if (swatch.dataset.variantImageAlt) {
      image.alt = swatch.dataset.variantImageAlt;
    }

    mediaGallery.classList.add('product-card-media-gallery--variant-preview');

    const sliderComponent = mediaGallery.querySelector('slider-component');
    if (!sliderComponent || !sliderComponent.slider) return;

    sliderComponent.slider.go(0);
  }

  #updateSelectedSwatch(selectedSwatch) {
    for (const swatch of this.querySelectorAll('[aria-checked="true"]')) {
      swatch.removeAttribute('aria-checked');
    }

    selectedSwatch.setAttribute('aria-checked', 'true');
  }

  #updateQuickAdd(selectedSwatch) {
    const productCard = this.closest('product-card');
    if (!productCard) return;

    const quickAdd = productCard.querySelector('quick-add-component');
    if (!quickAdd) return;

    const addToCartButton = quickAdd.querySelector('[data-ref="add-to-cart-button"]');
    if (addToCartButton && selectedSwatch.dataset.variantId) {
      addToCartButton.dataset.variantId = selectedSwatch.dataset.variantId;
    }

    const popupToggle = quickAdd.querySelector('[data-ref="popup-toggle"]');
    if (popupToggle && selectedSwatch.dataset.href) {
      popupToggle.dataset.productPageUrl = selectedSwatch.dataset.href;
    }
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}